import { Select } from 'antd';
import styled from 'styled-components';
export const ParentIdSelect = styled(Select)`
  max-height: 52px;

  .ant-select-selection-placeholder {
    line-height: 50px !important;
  }

  input {
    height: 100% !important;
  }

  [class*='ant-select-selector'] {
    height: 52px !important;
  }

  [class*='ant-select-selection-item'] {
    display: flex;
    align-items: center;
  }
`;
export const Error = styled.div`
  color: red;
`;